import React from 'react';
import HelpTooltip from '../HelpTooltip';
import OeTip from './OeTip';
import {WIZ_LAST, WIZ_STEPS, stepOf, wizAdjacent, wizDone, wizSkip} from './wizard';

// Breadcrumb, Schritt-Info und Navigation des geführten Ablaufs (Original
// `renderWizard`, 3289–3331; ABGLEICH E43–E45, G2, G42, G44).
//
// Der Ablauf ist frei navigierbar: jeder Eintrag der Leiste ist anklickbar, es
// gibt keine harte Sperre zwischen den Schritten. Schritte ohne Aufgabe werden
// gar nicht gezeigt — außer der gerade aktive, sonst stünde die Leiste ohne
// aktiven Eintrag da.

/** Erklärung je Schritt in der Sprechblase der Breadcrumb. */
function stepTip(s, done, skip) {
    if (skip) {
        return `${s.label}: In diesem Auftrag gibt es hier nichts zu tun — der Schritt wird beim Blättern `
            + 'übersprungen. Anklicken geht trotzdem.';
    }
    return `${s.label}: ${s.title}${done ? ' — erledigt.' : ''}`;
}

export function WizardRail({ctx, step, onStep}) {
    const sichtbar = WIZ_STEPS.filter((s) => !wizSkip(s, ctx) || s.n === step);

    return (
        <div className="wizrail" role="tablist" aria-label="Schritte des Auftrags">
            {sichtbar.map((s, i) => {
                const done = wizDone(s, ctx);
                const skip = wizSkip(s, ctx);
                const aktiv = s.n === step;
                const klassen = ['wizstep', aktiv ? 'on' : '', done ? 'done' : '', skip ? 'skip' : '']
                    .filter(Boolean)
                    .join(' ');

                return (
                    <React.Fragment key={s.n}>
                        {i > 0 ? <span className="wizsep" aria-hidden="true">›</span> : null}
                        <OeTip placement="bottom" tip={stepTip(s, done, skip)}>
                            <button
                                type="button"
                                className={klassen}
                                role="tab"
                                aria-selected={aktiv}
                                onClick={() => onStep(s.n)}
                            >
                                <span className="wn">{done && !aktiv ? '✓' : s.n}</span>
                                {s.label}
                            </button>
                        </OeTip>
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export function WizardStepInfo({step}) {
    const cur = stepOf(step);

    return (
        <div className="wizstepinfo">
            <span className="wizstepline">Schritt {cur.n} von {WIZ_LAST} · {cur.title}</span>
            <HelpTooltip
                id="oe-wizstep-help"
                placement="bottom"
                size={0.7}
                detail={<>
                    Zuerst der Schneider-Lieferschein (er braucht am längsten), dann der Kommissionierschein ans
                    Lager, danach das Ergebnis der Kommissionierung, zuletzt der Lahr-Lieferschein.
                </>}
            >
                Der Ablauf folgt dem tatsächlichen Weg der Ware. Du kannst jeden Schritt in der Leiste darüber
                direkt anspringen.
            </HelpTooltip>
        </div>
    );
}

export function WizardNav({ctx, step, onStep}) {
    const prevN = wizAdjacent(step, -1, ctx);
    const nextN = wizAdjacent(step, +1, ctx);

    return (
        <div className="wiznav">
            <OeTip tip={prevN === null
                ? 'Es gibt keinen vorigen Schritt mit einer Aufgabe.'
                : `Zurück zu Schritt ${prevN} (${stepOf(prevN).label}). Es wird nichts gespeichert oder gesendet.`}>
                <button type="button" disabled={prevN === null} onClick={() => onStep(prevN)}>
                    ← Zurück
                </button>
            </OeTip>
            <OeTip tip={nextN === null
                ? 'Es gibt keinen weiteren Schritt mit einer Aufgabe.'
                : `Weiter zu Schritt ${nextN} (${stepOf(nextN).label}). Es wird nichts gespeichert oder gesendet.`}>
                <button type="button" className="next" disabled={nextN === null} onClick={() => onStep(nextN)}>
                    Weiter →
                </button>
            </OeTip>
        </div>
    );
}
